<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onClick('all', $event)" />
          <svg
            v-if="!isDeleted"
            class="tooth__parts"
            fill="none"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M47.1077 68.7279H47.1078C46.4137 59.6238 44.8173 39.2142 43.9844 30.4079C42.9433 19.4 35.1413 7.14589 32.6426 3.5112C30.1439 -0.123482 25.667 -0.538879 26.7081 6.5228C27.7493 13.5845 28.6797 27.7078 28.2632 31.5502C27.8468 35.3926 25.8686 46.8159 25.3481 49.2044C24.9316 51.1152 24.0768 63.1547 23.7014 68.9355C34.6409 68.7279 40.0819 68.7279 47.1077 68.7279Z"
              v-bind:class="{ selected: isSelected('root_1') }"
              v-bind:fill="partColor['root_1'] || '#FFF'"
              v-on:click="onClick('root_1', $event)"
              v-on:keydown="onClick('root_1', $event)" />
            <path
              d="M37.6469 53.7536L38.6222 53.5046C39.0429 53.3971 39.4233 53.1693 39.7166 52.8491C40.2725 52.2424 40.4707 51.3918 40.2581 50.5968C36.3716 36.0609 35.9968 17.5888 35.0332 14.0974C35.001 13.9808 34.9443 13.8851 34.8675 13.7916C34.5707 13.4306 34.0186 13.4009 33.7216 13.7618C33.6201 13.8852 33.5469 13.9884 33.5484 14.0282C34.0427 27.1493 32.7762 44.1223 30.9342 51.5952L30.7918 52.2197C30.682 52.7012 30.8304 53.205 31.1837 53.5501C31.3871 53.7489 31.6456 53.8819 31.9256 53.9319L32.7464 54.0785L34.1918 54.1358L35.6066 54.042L37.6469 53.7536Z"
              v-bind:class="{ selected: isSelected('central_canal') }"
              v-bind:fill="partColor['central_canal'] || '#FF82BE'"
              v-on:click="onClick('central_canal', $event)"
              v-on:keydown="onClick('central_canal', $event)" />
            <path
              d="M45.1369 89.6022C41.139 93.7561 37.2179 95.1753 35.3439 95.21C35.0811 95.142 34.8231 95.0672 34.5699 94.9859C24.6013 91.7864 19.0993 78.3397 23.7023 68.9364C24.1687 67.9836 26.074 64.1359 26.709 63.2247C31.4566 56.4123 37.7104 57.2708 40.2438 58.5516C41.7361 59.4516 45.2413 64.0555 47.1087 68.7287C48.6027 72.4672 49.5444 77.625 49.3015 79.9443C49.1974 81.502 49.1349 85.4482 45.1369 89.6022Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <top-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import TopToothSurface from '../TopToothSurface.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';

export default {
  components: {
    TopToothSurface,
    FormTeethFormulaDiagnoses,
    ToothPopoverMenu,
  },
  mixins: [toothMixin],
  name: 'ToothUp3',
};
</script>

<style scoped></style>
